// Mock data de planes de seguro de auto

export const MOCK_PLANS = [
  {
    id: 'plan-esencial',
    name: 'Plan Esencial',
    description: 'Complementa el SOAT.',
    detailedDescription: 'Para quienes quieren protección básica ante accidentes o enfermedades.',
    type: 'esencial',
    tag: 'Más económico',
    monthlyPremium: 39400,
    annualPremium: 472800,
    deductible: 1500000,
    isRecommended: false,
    coverages: [
      {
        id: 'rc-danos',
        name: 'Daños a otras personas, vehículos o bienes ajenos hasta por 1.040 millones.',
        included: true,
        category: 'cobertura',
      },
      {
        id: 'acc-conductor',
        name: 'Accidentes personales para el conductor hasta por 50 millones.',
        included: true,
        category: 'cobertura',
      },
      {
        id: 'grua-taller',
        name: 'Asistencia de grúa y carro taller.',
        included: true,
        category: 'asistencia',
      },
      {
        id: 'taller-movil',
        name: 'Taller Móvil.',
        included: true,
        category: 'asistencia',
      },
      {
        id: 'paso-corriente-gasolina',
        name: 'Paso de corriente y paso de gasolina.',
        included: true,
        category: 'asistencia',
      },
      {
        id: 'danos-menores',
        name: 'Daños menores: llantas estalladas y rayones.',
        included: true,
        category: 'asistencia',
      },
      {
        id: 'recarga-ev',
        name: 'Recarga de vehículo eléctrico.',
        included: true,
        category: 'recarga',
      },
      {
        id: 'ambulancia-medica-excl',
        name: 'Ambulancia médica.',
        included: false,
      },
      {
        id: 'perdida-danos',
        name: 'Pérdida parcial o total por daños.',
        included: false,
      },
      {
        id: 'perdida-hurto',
        name: 'Pérdida parcial o total por hurto.',
        included: false,
      },
    ],
  },
  {
    id: 'plan-plus',
    name: 'Plan Plus',
    description: 'Coberturas que protegen tu carro.',
    type: 'plus',
    tag: 'Más elegido',
    monthlyPremium: 50450,
    annualPremium: 605400,
    deductible: 1000000,
    isRecommended: true,
    coverages: [
      {
        id: 'rc-danos',
        name: 'Daños a otras personas, vehículos o bienes ajenos hasta por 3.040 millones.',
        included: true,
        category: 'cobertura',
      },
      {
        id: 'acc-conductor',
        name: 'Accidentes personales para el conductor hasta por 50 millones.',
        included: true,
        category: 'cobertura',
      },
      {
        id: 'grua-taller',
        name: 'Asistencia de grúa y carro taller.',
        included: true,
        category: 'asistencia',
      },
      {
        id: 'taller-movil',
        name: 'Taller Móvil.',
        included: true,
        category: 'asistencia',
      },
      {
        id: 'ambulancia-medica',
        name: 'Ambulancia médica.',
        included: true,
        category: 'asistencia',
      },
      {
        id: 'paso-corriente-gasolina',
        name: 'Paso de corriente y paso de gasolina.',
        included: true,
        category: 'asistencia',
      },
      {
        id: 'danos-menores',
        name: 'Daños menores: llantas estalladas, rayones, vidrios, pequeños choques y accesorios.',
        included: true,
        category: 'asistencia',
      },
      {
        id: 'recarga-ev',
        name: 'Recarga de vehículo eléctrico.',
        included: true,
        category: 'recarga',
      },
      {
        id: 'perdida-danos',
        name: 'Pérdida parcial o total por daños.',
        included: false,
      },
      {
        id: 'perdida-hurto',
        name: 'Pérdida parcial o total por hurto.',
        included: false,
      },
    ],
  },
  {
    id: 'plan-total',
    name: 'Plan Total',
    description: 'Coberturas y beneficios exclusivos.',
    type: 'total',
    tag: 'Más coberturas',
    monthlyPremium: 39400,
    annualPremium: 472800,
    deductible: 500000,
    isRecommended: false,
    coverages: [
      {
        id: 'rc-danos',
        name: 'Daños a otras personas, vehículos o bienes ajenos hasta por 4.100 millones.',
        included: true,
        category: 'cobertura',
      },
      {
        id: 'perdida-danos-hurto',
        name: 'Pérdida total por daños o hurto.',
        included: true,
        category: 'cobertura',
      },
      {
        id: 'grua-taller',
        name: 'Asistencia de grúa y carro taller.',
        included: true,
        category: 'asistencia',
      },
      {
        id: 'taller-movil',
        name: 'Taller Móvil.',
        included: true,
        category: 'asistencia',
      },
      {
        id: 'ambulancia-medica',
        name: 'Ambulancia médica.',
        included: true,
        category: 'asistencia',
      },
      {
        id: 'paso-corriente-gasolina',
        name: 'Paso de corriente y paso de gasolina.',
        included: true,
        category: 'asistencia',
      },
      {
        id: 'danos-menores',
        name: 'Daños menores: llantas estalladas, rayones, vidrios, pequeños choques y accesorios.',
        included: true,
        category: 'asistencia',
      },
      {
        id: 'recarga-ev',
        name: 'Recarga de vehículo eléctrico.',
        included: true,
        category: 'recarga',
      },
      {
        id: 'acc-conductor-excl',
        name: 'Accidentes personales para el conductor.',
        included: false,
      },
    ],
  },
];
